import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

interface AsianLinesProviderProps {
    children: ReactNode;
}

interface AsianLinesContextType {
    isFullTime: boolean;
    isOpen: boolean;
    openMoreAsianLines(isFullTime: boolean): void;
    closeMoreAsianLines(): void;
}


const AsianLinesContext = createContext<AsianLinesContextType>({
	isOpen: false,
	isFullTime: false,
	openMoreAsianLines: () => {},
	closeMoreAsianLines: () => {}
});
export const useAsianLines = (): AsianLinesContextType => useContext(AsianLinesContext);

export const AsianLinesProvider = ({ children }: AsianLinesProviderProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isFullTime, setIsFullTime] = useState(false);

	const openMoreAsianLines = (isFullTime: boolean) => {
		setIsOpen(true);
		setIsFullTime(isFullTime);
	}

	const closeMoreAsianLines = () => {
		setIsOpen(false);
	} 
    
	const value: AsianLinesContextType = useMemo(() => ({
		isFullTime,
		isOpen,
		openMoreAsianLines,
		closeMoreAsianLines
	}), [isFullTime, isOpen]);
	
	return (
		<AsianLinesContext.Provider value={value}>
			{ children } 
		</AsianLinesContext.Provider>
	);
}